import { render, staticRenderFns } from "./PriceSlash.vue?vue&type=template&id=5e5396dc&"
import script from "./PriceSlash.vue?vue&type=script&lang=js&"
export * from "./PriceSlash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports